"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalStyles = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const GlobalStyles_1 = __importDefault(require("@mui/material/GlobalStyles"));
const TableCell_1 = require("@mui/material/TableCell");
exports.globalStyles = ((0, jsx_runtime_1.jsx)(GlobalStyles_1.default, { styles: (theme) => ({
        body: {
            color: theme.colours.charcoal,
            margin: "0",
            fontSize: "1.125rem",
            fontFamily: "Effra Regular",
            fontWeight: "400",
            lineHeight: "1.4",
            backgroundColor: theme.colours.white
        },
        "@media print": {
            body: {
                backgroundColor: theme.colours.white
            }
        },
        "body::backdrop": {
            backgroundColor: theme.colours.white
        },
        [`${theme.breakpoints.up(1024)}`]: {
            html: {
                fontSize: "1.125rem"
            }
        },
        [`.${TableCell_1.tableCellClasses.head}, .${TableCell_1.tableCellClasses.body}`]: {
            fontSize: "16px",
            [theme.breakpoints.up("sm")]: {
                fontSize: "18px"
            }
        },
        "@media(hover: hover)": {
            "*": {
                scrollbarColor: "#c2c2c2 transparent",
                scrollbarWidth: "thin"
            },
            /* width */
            "::-webkit-scrollbar": {
                width: "6px"
            },
            /* Track */
            "::-webkit-scrollbar-track": {
                boxShadow: "inset 0 0 0 transparent"
            },
            /* Handle */
            "::-webkit-scrollbar-thumb": {
                background: "#c2c2c2",
                borderRadius: "10px"
            }
        }
    }) }));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsU3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RoZW1lLXByb3ZpZGVyL2dsb2JhbFN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLDhFQUFzRDtBQUN0RCx1REFBMkQ7QUFFOUMsUUFBQSxZQUFZLEdBQUcsQ0FDMUIsdUJBQUMsc0JBQVksSUFDWCxNQUFNLEVBQUUsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDbEIsSUFBSSxFQUFFO1lBQ0osS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtZQUM3QixNQUFNLEVBQUUsR0FBRztZQUNYLFFBQVEsRUFBRSxVQUFVO1lBQ3BCLFVBQVUsRUFBRSxlQUFlO1lBQzNCLFVBQVUsRUFBRSxLQUFLO1lBQ2pCLFVBQVUsRUFBRSxLQUFLO1lBQ2pCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7U0FDckM7UUFDRCxjQUFjLEVBQUU7WUFDZCxJQUFJLEVBQUU7Z0JBQ0osZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSzthQUNyQztTQUNGO1FBQ0QsZ0JBQWdCLEVBQUU7WUFDaEIsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUNyQztRQUNELENBQUMsR0FBRyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQUU7WUFDakMsSUFBSSxFQUFFO2dCQUNKLFFBQVEsRUFBRSxVQUFVO2FBQ3JCO1NBQ0Y7UUFDRCxDQUFDLElBQUksNEJBQWdCLENBQUMsSUFBSSxNQUFNLDRCQUFnQixDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7WUFDeEQsUUFBUSxFQUFFLE1BQU07WUFDaEIsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO2dCQUM1QixRQUFRLEVBQUUsTUFBTTthQUNqQjtTQUNGO1FBQ0Qsc0JBQXNCLEVBQUU7WUFDdEIsR0FBRyxFQUFFO2dCQUNILGNBQWMsRUFBRSxxQkFBcUI7Z0JBQ3JDLGNBQWMsRUFBRSxNQUFNO2FBQ3ZCO1lBQ0QsV0FBVztZQUNYLHFCQUFxQixFQUFFO2dCQUNyQixLQUFLLEVBQUUsS0FBSzthQUNiO1lBQ0QsV0FBVztZQUNYLDJCQUEyQixFQUFFO2dCQUMzQixTQUFTLEVBQUUseUJBQXlCO2FBQ3JDO1lBQ0QsWUFBWTtZQUNaLDJCQUEyQixFQUFFO2dCQUMzQixVQUFVLEVBQUUsU0FBUztnQkFDckIsWUFBWSxFQUFFLE1BQU07YUFDckI7U0FDRjtLQUNGLENBQUMsR0FDRixDQUNILENBQUMifQ==